import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISlotList } from "../../../Pages/Slot/ISlot";

interface IUpdate extends IReduxState<ISlotList> {
  updateableDate?: ISlotList;
}

export const UpdateSlotSlicer = createSlice({
  name: "UpdateSlot",
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateSlot: (state, _) => {
      state.isLoading = true;
    },
    successUpdateSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateSlot: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    SlotsUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateSlotState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
    clearUpdateableData: (state) => {
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateSlot,
  failureUpdateSlot,
  successUpdateSlot,
  SlotsUpdateableData,
  clearUpdateSlotState,
  clearUpdateableData,
} = UpdateSlotSlicer.actions;

export default UpdateSlotSlicer.reducer;
